import { observable, toJS } from "mobx";
import { montarSelectOption, situacaoFormatter, formatarDataCustomHTML, formatNullableValue, agendamentoServPopOver } from '../../../../utils/formatar';
import { buscaSemResultado, buscaFiltrarVazio } from "../../../../utils/mensagens";
import React from "react";
import { sortCaret, DocumentoView } from "../../../comum/components/Icones";
import PopupOpenIcone from "../../../comum/components/PopupOpenIcone";
import { urlApi } from '../../../../config/Constantes';

import moment from "moment";

export default class AgServicoVisualizarStore {

    @observable filtroListar;
    @observable filtroValor;
    @observable estadoFiltros;

    @observable items;
    @observable containerAgendamentoList;
    @observable colunas;
    @observable loading;
    @observable tableMessage;
    @observable total;
    @observable filtrado;
    @observable containersDoModalQuantidade;

    @observable modalCancelar;
    @observable mensagemErro;
    @observable agendServIdSelecionado;
    @observable loadingTicketVGM;

    constructor(service) {
        this.loading = false;
        this.total = null;
        this.filtrado = false;

        this.items = [];
        this.lista = [];
        this.containerAgendamentoList = [];
        this.toShow = 20;
        this.turn = 0;
        this.colunas = this.todasColunas.slice(0);
        this.tableMessage = buscaFiltrarVazio;

        this.containersDoModalQuantidade = false;

        this.estadoFiltros = false;

        this.filtroListar = {
            grupos: null,
            tiposGrupos: null,
            status: null,
            cliente: null
        };

        this.filtroValor = {
            grupos: null,
            tiposGrupos: null,
            status: {label: "Agendado", value: "P"},
            cliente: null,
            numeroBL: null,
            dataInicial: moment().add(0, 'day').format("YYYY-MM-DD"),
            dataFinal: moment().add(5, 'day').format("YYYY-MM-DD"),
            usuario: null,
        }

        this.modalCancelar = false;
        this.mensagemErro = "";
        this.agendServIdSelecionado = null;

        this.loadingTicketVGM = false;

        this.download = document.createElement('a');
        document.body.appendChild(this.download);
        this.download.style = "display: none";
        this.download.target = "_blank";

        this.service = service;

        this.listarGrupos();
        this.listarStatus();
        this.listarClientes();
    }

    getTicketVGM = (doc) => {
        if (doc != null)
        {
            console.log(`entered in getTicketVGM(${doc})`)
            this.loadingTicketVGM = true;
            let fetchURL =`${urlApi}/AgendServManter/DownloadAnexo/${doc}`;
            fetch(fetchURL)
                .then(r =>{
                    if(r.status !== 200) {
                        console.log(r)
                        if(r.status === 404) {
                            this.mensagem = "Nada foi encontrado. Código 404.";
                        } else {
                            this.mensagem = r.data;
                        }
                    }
                    else 
                    {
                        this.download.href = fetchURL;
                        this.download.click();
                    }
                }).catch(err => console.log(err)
                ).finally(() => {this.loadingTicketVGM = false}); 
        }
    }

    gerarTicketPesagem = (gkeyContainer) => {
        if(gkeyContainer) {
            this.loadingTicketVGM = true;
            fetch(`${urlApi}/Container/TicketPesagem/${gkeyContainer}`).then(res => {
                if(res.status !== 200) {
                    this.mensagemErro = "Não foi possível completar o download"; 
                } else {
                    return res.blob();
                } 
            }).then(blob => {
                const url = window.URL.createObjectURL(blob)
                this.download.href = url
                this.download.download = `ticket_pesagem_${gkeyContainer}.pdf`
                this.download.click()
                window.URL.revokeObjectURL(url)
            }).catch(err => {console.error(err); this.mensagemErro = "Erro ao fazer o download"}
            ).finally(() => {
                this.loadingTicketVGM = false;
            });
        }
    }

    gerarRelatorioPesagem = (gkeyContainer, item) => {

        if(gkeyContainer) {
            this.loadingTicketVGM = true;
            fetch(`${urlApi}/Container/RelatorioPesagem/${gkeyContainer}`).then(res => {
                if(res.status !== 200) {
                    this.mensagemErro = "Não foi possível completar o download"; 
                } else {
                    return res.blob();
                } 
            }).then(blob => {
                const url = window.URL.createObjectURL(blob)
                this.download.href = url
                this.download.download = `relatorio_pesagem_${gkeyContainer}.pdf`
                this.download.click()
                window.URL.revokeObjectURL(url)
            }).catch(err => {console.error(err); this.mensagemErro = "Erro ao fazer o download"}
            ).finally(() => {
                this.loadingTicketVGM = false;
            });
        }
    }

    fechaModais = () => 
    {
        this.modalCancelar = false;
    }

    setIdRow = (id) => {
        this.agendServIdSelecionado = id;
    }

    listarGrupos = () => {
        this.service.listarGrupos().then(response => {
            this.filtroListar.grupos = montarSelectOption("Id", "DscGrupo", response.data);
        }).catch(err => {
            console.log(`listarGrupos : ${err}`);
        })
    }

    listarTipos = (grupo) => {
        this.service.listarTipos(grupo).then(response => {
            this.filtroListar.tiposGrupos = montarSelectOption("AgendTipoServId", "DscTipoServ", response.data);
        }).catch(err => {
            console.log(`listarGrupos : ${err}`);
        })
    }

    listarStatus = () => {
        this.service.listarStatus().then(response => {
            this.filtroListar.status = montarSelectOption("Id.RvLowValue", "RvMeaning", response.data);
        }).catch(err => {
            console.log(`listarStatus : ${err}`);
        })
    }

    listarClientes = () => {
        this.service.listarClientes().then(response => {
            this.filtroListar.cliente = montarSelectOption("EmpprccmrNmEmpParcComerc", "NomeFantEstabParcComerc", response.data);
        }).catch(err => {
            console.log(`listarClientesEstrangeiros : ${err}`);
        })
    }

    listarContainerPorBl = (bl) => {
        this.containerAgendamentoList = [];
        this.service.listarContainerPorBl(bl).then(response => {
            if (response.data)
                this.containerAgendamentoList = response.data;
        }).catch(err => {
            console.log(`listarContainerPorBl : ${err}`);
        })
    }

    setFilter = (field, value) => {
        this.filtroValor[field] = value !== null ? value : false;
    }

    onChangeFiltroGrupos = (value) => {
        this.filtroValor.grupos = value !== null ? value : false;
        if (this.filtroValor.grupos.value) {
            this.listarTipos(this.filtroValor.grupos.value);
        }
        else
            this.filtroListar.tiposGrupos = false;
    };

    listarTipos = (grupoServId) => {
        this.filtroListar.tiposGrupos = false;
        this.filtroValor.tiposGrupos = null;
        this.service.listarTipos(grupoServId).then(response => {
            if (response.data)
                this.filtroListar.tiposGrupos = montarSelectOption("AgendTipoServId", "DscTipoServ", response.data);
        });
    };

    listarAgendamentos() {
        this.estadoFiltros = Object.assign({}, this.filtroValor);
        this.fazerListar();
    };

    reListar = () => {
        this.fazerListar();
    };

    fazerListar = () => {
        this.filtrado = true;
        this.loading = true;
        this.items = []
        this.lista = []

        this.service.listar(
            // TODO Retornar para variaveis
            this.filtroValor.grupos ? this.filtroValor.grupos.value : null,
            this.filtroValor.tiposGrupos ? this.filtroValor.tiposGrupos.value : null,
            this.filtroValor.dataInicial, // "2018-01-03",
            this.filtroValor.dataFinal, // "2019-11-03",
            this.estadoFiltros.usuario,
            this.estadoFiltros.cliente ? this.estadoFiltros.cliente.value : false,
            this.estadoFiltros.status ? this.estadoFiltros.status.value : false,
            this.estadoFiltros.numeroBL,
            this.estadoFiltros.container).then(response => {
                this.lista = response.data.ListaAgend;
                this.total = response.data.ListaAgend.length;

                if (this.total === 0) {
                    this.tableMessage = buscaSemResultado;
                } else {
                    this.tableMessage = buscaFiltrarVazio;
                }
                this.lista.map(ag => {
                    ag.QtdCntrAgend = ag.ListItens.length;
                });

                this.loadFirstTurn();
            }).catch(err => {
                console.log('err LISTAR', err)
            }).finally(fin => {
                this.loading = false;
            });
    }

    loadFirstTurn = () => {
        this.items = this.lista.slice(0, this.toShow);
        this.turn = 1;
        this.hasMore = this.items.length < this.lista.length;
    };

    loadNextTurn = () => {
        this.items = [];
        this.items = this.lista.slice(0, (this.turn + 1) * this.toShow);
        this.turn = this.turn + 1;

        this.hasMore = this.items.length < this.items.length;
    };

    getLista() {
        return this.items;
    }

    getListaCopia() {
        return toJS(this.items)
    }

    abrirModalQuantidadeContainer = (row) => {
        this.containersDoModalQuantidade = row.ListItens;
    }

    cancelarAgendamento = () => {        
        this.service.cancelar(this.agendServIdSelecionado).then(response => {
            this.mensagemErro="";
            if (response.data.Sucesso)
            {   
                this.listarAgendamentos();
                this.fechaModais();                
                return true;
            }
            else
            {
                this.fechaModais();
                this.mensagemErro = response.data.Mensagem;
                return false;
            }
        }).catch(err => {
            console.log(`listarContainerPorBl : ${err}`);
        })
    }

    renderQuantidadeContainer = (row) => {
        if (!row) return null
        return (
            (row.QtdCntrAgend && row.QtdCntrAgend > 0) ?
                <span className="clicavel" onClick={() => this.abrirModalQuantidadeContainer(row)}>
                    <span className="label-primary underline inline">{row.QtdCntrAgend}</span> &nbsp;
                <PopupOpenIcone></PopupOpenIcone>
                </span>
                : <span> -- </span>
        );
    }

    renderTicketPesagem = (cell, row) => {
        if (row.AgendGrupoServId===5 && row.ListAnexos && row.ListAnexos.length > 0){
            console.log(`Render TicketPesagem row.ListAnexos[0] = ${row.ListAnexos[0]}`)
            return <span className="float-right" onClick={() => this.getTicketVGM(row.ListAnexos[0].Id)}><DocumentoView style={{cursor: 'pointer'}} width={24} /></span>
        } else if (row.AgendTipoServId===107 && row.ListItens && row.ListItens.length > 0) {
            return  ( row.ListItens.map(item => { return <span className="float-right" onClick={() => this.gerarRelatorioPesagem(item.UnitId)}><DocumentoView style={{cursor: 'pointer'}} width={24} /></span> }))
        }
    }


    renderTicketVGM = (cell, row) => {
        if (row.AgendGrupoServId===5 && row.ListAnexos && row.ListAnexos.length > 0){
            console.log(`Render renderTicketVGM row.ListAnexos[0] = ${row.ListAnexos[0]}`)
            return <span className="float-right" onClick={() => this.getTicketVGM(row.ListAnexos[0].Id)}><DocumentoView style={{cursor: 'pointer'}} width={24} /></span>
        } else if (row.AgendTipoServId===107 && row.ListItens && row.ListItens.length > 0) {
            return  ( row.ListItens.map(item => { return <span className="float-right" onClick={() => this.gerarTicketPesagem(item.UnitId)}><DocumentoView style={{cursor: 'pointer'}} width={24} /></span> }))
        }
    }

    todasColunas = [
        {
            dataField: "DscTipoServ",
            text: "Serviço",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatNullableValue,
            headerAlign: (column, colIndex) => 'left'
        },
        {
            dataField: "DatIniPrev",
            text: "Início Prev.",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML,
            headerAlign: (column, colIndex) => 'left',
        },
        {
            dataField: "NumeroBl",
            text: "Número BL",
            sort: true,
            sortCaret: sortCaret,
            // formatter: appendFieldSpan,
            // formatExtraData: 'CodViagem',
            formatter: formatNullableValue,
            headerAlign: (column, colIndex) => 'left'
        },
        {
            dataField: "Placa",
            text: "Placa",
            sort: true,
            // sortCaret: sortCaret,
            formatter: formatNullableValue,
            headerAlign: (column, colIndex) => 'left'
        },
        {
            dataField: "DatSaidaVeic",
            text: "Saída Veículo",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: (column, colIndex) => 'left',
            formatter: formatarDataCustomHTML
        },
        {
            dataField: "QtdCntrAgend",
            text: "Qtd Cntr",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: (column, colIndex) => 'left',
            formatter: agendamentoServPopOver,
            headerStyle: () => { return { maxWidth: "60px" }; },
        },
        process.env.ssa?
        {
            text: "Ticket Pesagem/VGM",
            dataField: 'link',
            align: "center",
            isDummyField: true,
            formatter: (cell, row) => this.renderTicketVGM(cell, row),
        }:{
            text: "Ticket Pesagem/VGM",
            dataField: 'link',
            align: "center",
            isDummyField: true,
            formatter: (cell, row) => this.renderTicketPesagem(cell, row),
        },
        {
            dataField: "DscIndStatus",
            text: "Situação",
            sort: true,
            sortCaret: sortCaret,
            formatter: situacaoFormatter,
        }
    ];

    colunasExportacao = [
        {
            dataField: "DscTipoServ",
            text: "Serviço",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatNullableValue
        },
        {
            dataField: "DatIniPrev",
            text: "Início Prev.",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML
        },
        {
            dataField: "NumeroBl",
            text: "Número BL",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatNullableValue
        },
        {
            dataField: "Placa",
            text: "Placa",
            sort: true,
            formatter: formatNullableValue
        },
        {
            dataField: "DatSaidaVeic",
            text: "Saída Veículo",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML
        },
        {
            dataField: "QtdCntrAgend",
            text: "Qtd Cntr",
            sort: true,
            sortCaret: sortCaret
        },
        {
            dataField: "DscIndStatus",
            text: "Situação",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatNullableValue
        } ,{
            dataField: "Cliente",
            text: "Cliente",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatNullableValue
        }, {
            dataField: "UsuIncl",
            text: "Criado por",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatNullableValue
        }, {
            dataField: "DatIncl",
            text: "Data e hora de inclusão",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML
        }, {
            dataField: "UsuAlt",
            text: "Alterado por",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatNullableValue
        }, {
            dataField: "DatUsuAlt",
            text: "Data e hora de alteração",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML
        }
    ]
}



// WEBPACK FOOTER //
// ./src/modules/agendamentoservicosTotal/visualizar/stores/AgServicosVisualizarStore.js